<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Journal Management</h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr class="no_wrap_th text-center">
                                        <th class="Sorting-img"> S.No.</th>
                                        <th class="Sorting-img">Questions</th>
                                        <th class="action_td_btn3 Sorting-img">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of JournalList; track item; let i = $index) {
                                    <tr class="text-center">
                                        <td>{{i+1}}</td>
                                        <td class="content text-left">
                                            <abbr [title]="item?.question">
                                                {{item?.question}}
                                            </abbr>
                                        </td>
                                        <td class="text-center action_td">
                                            <button class="btn btn-info ms-2 bt-margin" title="view"
                                                (click)="viewUser(item?._id)">
                                                <i class="fa fa-eye" style="color:white"></i></button>
                                            <button class="btn btn-info ms-2 bt-margin" (click)="editFaq(item?._id)"><i
                                                    class="fa fa-edit" style="color:white"></i></button>
                                        </td>
                                    </tr>
                                    }
                                    @if(JournalList.length == 0){
                                    <tr>
                                        <td class="table-no-record" colspan="4">No Record Found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- delete_modal Start -->
<div class="modal fade global-modal reset-modal" id="delete">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete FAQs?</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p class="text-nowrap">Are you sure you want to delete this faq?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="deleteFaq()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- delete_modal End -->